import { render } from "./BackButtonComponent.vue?vue&type=template&id=a90d83d4&scoped=true"
import script from "./BackButtonComponent.vue?vue&type=script&lang=js"
export * from "./BackButtonComponent.vue?vue&type=script&lang=js"

import "./BackButtonComponent.vue?vue&type=style&index=0&id=a90d83d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a90d83d4"]])

export default __exports__